import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ProvisionService } from 'src/services/provision/provision.service';
import { StateService } from 'src/services/state/state.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
    selector: 'conversion-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit, OnDestroy {
    provisionBusy = false;
    private subscriptions: Subscription[] = [];

    constructor(public provisionService: ProvisionService,
                router: Router,
                private stateService: StateService) {
        router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

    ngOnInit(): void {
        this.subscriptions.push(this.stateService.getProvisionBusyUpdates().subscribe(busy => this.provisionBusy = busy));
    }


    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.provisionService.clearData();
    }
}
